import React from 'react';
import './HelpOverlay.css';

interface HelpOverlayProps {
  onClose: () => void;
}

const HelpOverlay: React.FC<HelpOverlayProps> = ({ onClose }) => {
  return (
    <div className="help-overlay">
      <div className="help-content">
        <div className="help-header">
          <h2>How to Play Heroes of the Grid</h2>
          <button onClick={onClose} className="close-help-btn">×</button>
        </div>

        <div className="help-body">
          <section className="help-section">
            <h3>Getting Started</h3>
            <ul>
              <li><strong>Characters:</strong> View and manage your heroes. Each character has unique stats and abilities.</li>
              <li><strong>World Map:</strong> Explore different regions and start battles against monsters.</li>
              <li><strong>Crafting:</strong> Create weapons, armor, and items using materials gathered from battles.</li>
            </ul>
          </section>

          <section className="help-section">
            <h3>Battle System</h3>
            <ul>
              <li><strong>Turn Order:</strong> Characters act based on initiative (Dexterity stat).</li>
              <li><strong>Action Points (AP):</strong> Used to perform attacks and cast skills.</li>
              <li><strong>Movement:</strong> Click "Move" then click a highlighted tile to move your character.</li>
              <li><strong>Attacking:</strong> Click "Attack" then click an enemy in range to attack.</li>
              <li><strong>Skills:</strong> Click "Cast Skill", select a skill, then target an enemy or area.</li>
            </ul>
          </section>

          <section className="help-section">
            <h3>Character Stats</h3>
            <ul>
              <li><strong>HP (Health Points):</strong> When it reaches 0, your character falls in battle.</li>
              <li><strong>Strength:</strong> Increases physical damage.</li>
              <li><strong>Vitality:</strong> Increases max HP.</li>
              <li><strong>Constitution:</strong> Increases max HP and defense.</li>
            </ul>
          </section>

          <section className="help-section">
            <h3>Tips</h3>
            <ul>
              <li>Position your characters wisely - ranged units work best from a distance!</li>
              <li>Use the terrain to your advantage - enemies must move to reach you.</li>
              <li>Don't forget to craft equipment to boost your stats.</li>
              <li>Gather materials from battles to unlock more powerful recipes.</li>
              <li>Balance your team with different character classes for best results.</li>
            </ul>
          </section>
        </div>

        <div className="help-footer">
          <button onClick={onClose} className="got-it-btn">Got it!</button>
        </div>
      </div>
    </div>
  );
};

export default HelpOverlay;
